import React, { PureComponent } from "react";
import styled from "styled-components";
import Emoji from "../Emoji/Emoji";
import { colors } from "../../theme";

const ErrorContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 555;
  background-color: ${colors.red};
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  color: white;
`;

class ErrorView extends PureComponent {
  state = {
    detailsShown: false
  };

  render() {
    const { detailsShown } = this.state;
    const { error } = this.props;
    return (
      <ErrorContainer>
        <div>
          <h1 onDoubleClick={() => this.setState({ detailsShown: true })}>
            Er is iets foutgelopen <Emoji>:frowning:</Emoji>
          </h1>
          <p>Probeer later nog eens.</p>
          {detailsShown ? <pre>{JSON.stringify(error, null, 4)}</pre> : null}
        </div>
      </ErrorContainer>
    );
  }
}

export default ErrorView;



// WEBPACK FOOTER //
// ./src/components/Error/index.js